import src from "IMAGE";
export default { src, width: 56, height: 56, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANUlEQVR42q2OMQoAMAwCQ61Q///h4hDI1HTITSqIRvwg6ZDc6a2dRQ0ArPTWtTBAO9GefHEBrmABUR7ZTE0AAAAASUVORK5CYII="};
